import React from 'react';

export const serializers = {
  types: {
    block: props => {
      switch (props.node.style) {
        case 'h6':
          return <h6>{props.children}</h6>;

        case 'h5':
          return <h5>{props.children}</h5>;

        case 'h4':
          return <h4>{props.children}</h4>;

        case 'h3':
          return <h3>{props.children}</h3>;

        case 'h2':
          return <h2>{props.children}</h2>;

        case 'h1':
          return <h1>{props.children}</h1>;

        default:
          return <p>{props.children}</p>;
      }
    },
  },
  marks: {
    link: props => {
      return (
        <a className="secondary-color" href={props.mark.href} target="_blank">
          {props.children}
        </a>
      );
    },
  },
};
